import { render } from "./MentorProfileStatusVx.vue?vue&type=template&id=5fd18d56&scoped=true"
import script from "./MentorProfileStatusVx.vue?vue&type=script&lang=js"
export * from "./MentorProfileStatusVx.vue?vue&type=script&lang=js"

import "./MentorProfileStatusVx.vue?vue&type=style&index=0&id=5fd18d56&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd18d56"]])

export default __exports__